/**
 * Popover mount for `ViewVisibilityControl`: the full panel behind a trigger the
 * caller supplies. `children` is that trigger and is required — the matrix cell
 * passes its state chip, which is what makes the matrix and the single-object
 * mounts literally the same control. This component reads no pool of its own:
 * it mounts once per editable matrix cell, so an org-parameters subscription
 * here would cost one connect/disconnect round trip and one snapshot per cell of
 * the grid. The `Popover` is always mounted with `open` controlled and
 * `destroyOnHidden` set, so the closed state unmounts the panel's subscriptions
 * without destroying the exit animation — gating the overlay on `open` is
 * forbidden.
 */
import { FC, useState } from 'react';
import { Popover } from 'antd';
import { ViewVisibilityControl } from './ViewVisibilityControl';
import type { ViewVisibilityPopoverProps } from './ViewVisibility.types';

export const ViewVisibilityPopover: FC<ViewVisibilityPopoverProps> = ({ children, ...control }) => {
    const [open, setOpen] = useState(false);

    return (
        <Popover
            open={open}
            onOpenChange={setOpen}
            trigger="click"
            placement="bottomLeft"
            destroyOnHidden
            content={<ViewVisibilityControl {...control} aria-label={`${control['aria-label']} panel`} />}
        >
            {children}
        </Popover>
    );
};
